import React from 'react';
import { FileText, ClipboardList, Mail, Scale, Phone } from 'lucide-react';
export function BonusSection() {
  return <section className="bg-[#fdfbf7] py-12 md:py-20 px-6 border-y border-gold/20" data-id="element-103">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-editorial p-8 md:p-12 border-t-4 border-gold" data-id="element-104">
        <div className="inline-block bg-amber-100 text-amber-800 font-bold px-4 py-1 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-105">
          BONUS #1 — INCLUDED FREE
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-2" data-id="element-106">
          The Letter of Intent Template
        </h2>
        <p className="text-lg text-slate font-medium mb-8" data-id="element-107">
          Valued at $9.99. Yours free inside the kit.
        </p>

        <div className="space-y-4 text-text-dark font-body text-lg leading-relaxed mb-10" data-id="element-108">
          <p data-id="element-109">
            If the house you inherited has a reverse mortgage, you have a 30-day
            window from the date of the Due and Payable notice to respond — or
            the bank moves forward with foreclosure proceedings.
          </p>
          <p data-id="element-110">Most heirs don't find out until week three.</p>
          <p data-id="element-111">
            This fill-in template — two pages, sent by certified mail — legally
            buys you up to 6 months to decide what to do with the property.
            Sell, refinance, or keep it. On your timeline, not the bank's.
          </p>
        </div>

        <h3 className="text-xl font-bold text-navy mb-6" data-id="element-112">
          What's included in the template:
        </h3>
        <ul className="space-y-4 mb-10" data-id="element-113">
          <li className="flex items-start gap-3" data-id="element-114">
            <FileText className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-115" />
            <span className="text-text-dark text-lg" data-id="element-116">
              Complete Letter of Intent — ready to fill in and send
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-117">
            <ClipboardList className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-118" />
            <span className="text-text-dark text-lg" data-id="element-119">
              Pre-send checklist — everything you need to gather first
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-120">
            <Mail className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-121" />
            <span className="text-text-dark text-lg" data-id="element-122">
              Certified mail sending instructions — step by step
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-123">
            <Scale className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-124" />
            <span className="text-text-dark text-lg" data-id="element-125">
              Key terms glossary — so you understand every word
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-126">
            <Phone className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-127" />
            <span className="text-text-dark text-lg" data-id="element-128">
              Free HUD resources — including the free counseling hotline
            </span>
          </li>
        </ul>

        <p className="text-sm text-text-muted italic border-t border-slate-light/20 pt-6" data-id="element-129">
          For educational purposes only. We recommend consulting with a licensed
          attorney before sending any legal correspondence.
        </p>
      </div>
    </section>;
}